export default {
  state() {
    return {
      intro: false,

      levelStart: false,
      levelFail: false,
      levelFinish: false,

      character: false,

      currentTask: false,
      howToPlay: false,

      formSend: false
    };
  },
  mutations: {
    toggleModal(state, modal) {
      if (state[modal] !== undefined) {
        state[modal] = !state[modal];
      }
    }
  }
};
